import React, { useEffect, useState } from "react"

const STORAGE_KEY = "cookie-consent-accepted"

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY)
    if (!accepted) setVisible(true)
  }, [])

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "true")

    // Enable GA after consent
    if ((window as any).gtag) {
      (window as any).gtag("consent", "update", {
        analytics_storage: "granted",
      })
    }

    setVisible(false)
  }

  if (!visible) return null

  return (
    <div style={styles.container}>
      <span>
        We use cookies for analytics. See our	{" "}
        <a href="/privacy_policy">Privacy Policy</a>.
      </span>
      <button onClick={accept} style={styles.button}>
        OK
      </button>
    </div>
  )
}

const styles: { container: React.CSSProperties; button: React.CSSProperties } = {
  container: {
    position: "fixed",
    bottom: 16,
    left: 16,
    right: 16,
    maxWidth: 520,
    margin: "0 auto",
    padding: "12px 16px",
    background: "#111",
    color: "#fff",
    borderRadius: 8,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 14,
    zIndex: 9999,
  },
  button: {
    marginLeft: 16,
  },
}